import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { BarChart, Bar, XAxis, YAxis, Cell } from 'recharts';

class PersoneticsPinChart extends Component {

    render() {
        const { dataObject } = this.props;
        let barChartData;
        let reversedObject;
        if (dataObject.size > 0) {
            const categories = dataObject.get('categories');
            const series = dataObject.get('series').map(data => {
                return data.get('value')
            });
            barChartData = categories.map((x, i) => {
                return { "name": x, "state": series.get(`${i}`) }
            });
            reversedObject = barChartData && barChartData.toJS().reverse();
        }

        return (
            <BarChart
                width={350}
                height={220}
                data={reversedObject}
                layout="vertical"
            >
                <XAxis type="number" axisLine={false} tick={false} />
                <YAxis tickLine={false} dataKey="name" type="category" axisLine={false} />
                <Bar background dataKey="state" barSize={15} fill="#fbb800">
                    {
                        barChartData.map((data, index) => (
                            <Cell opacity={index == 0 ? '0.8' : '0.5'} />
                        ))
                    }
                </Bar>
            </BarChart>
        );
    }
}

PersoneticsPinChart.propTypes = {
    animationBegin: PropTypes.number,
    axisLine: PropTypes.bool,
    bars: PropTypes.array.isRequired,
    dataObject: PropTypes.array.isRequired,
    fills: PropTypes.array,
    height: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    interval: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    lastFills: PropTypes.array,
    legend: PropTypes.bool,
    margin: PropTypes.object,
    referenceLineData: PropTypes.object,
    referenceLineStroke: PropTypes.string,
    tooltip: PropTypes.bool,
    tooltipContent: PropTypes.func,
    unit: PropTypes.string,
    width: PropTypes.oneOfType([
        PropTypes.string,
        PropTypes.number,
    ]),
    xAxis: PropTypes.string.isRequired,
    xTickComponent: PropTypes.object
};

PersoneticsPinChart.defaultProps = {
    fills: [],
    legend: false,
    tooltip: true
}

export default PersoneticsPinChart;